import { render, staticRenderFns } from "./create.vue?vue&type=template&id=46e11c42&"
import script from "./create.vue?vue&type=script&lang=js&"
export * from "./create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46e11c42')) {
      api.createRecord('46e11c42', component.options)
    } else {
      api.reload('46e11c42', component.options)
    }
    module.hot.accept("./create.vue?vue&type=template&id=46e11c42&", function () {
      api.rerender('46e11c42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/virtual-account/create.vue"
export default component.exports